import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
/**
 * 文本框组件，继承Base
 * @module $ui/components/my-rate
 */

import { Rate } from 'element-ui';
import Base from '../Base';
export default {
  name: 'MyRate',
  mixins: [Base],
  components: {
    Rate: Rate
  },
  props: {
    value: Number
  },
  methods: {
    getDefaultValue: function getDefaultValue() {
      return 0;
    }
  },
  render: function render() {
    var _this = this;
    var h = arguments[0];
    var vnode = h(Rate, {
      "ref": 'comp',
      "class": 'my-rate',
      "props": _objectSpread({}, this.innerProps),
      "on": _objectSpread({}, this.$listeners),
      "attrs": _objectSpread({}, this.innerProps),
      "model": {
        value: _this.fieldValue,
        callback: function callback($$v) {
          _this.fieldValue = $$v;
        }
      }
    });
    return this.renderComponent(vnode);
  }
};